import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExportPage } from './export.component';
import { TranslateModule } from '@ngx-translate/core';
import { ToastService } from '@shared';
import { IonicModule } from '@ionic/angular';

@NgModule({
	declarations: [ExportPage],
	imports: [CommonModule, TranslateModule, IonicModule],
	providers: [ToastService]
})
export class ExportPageModule {}
